const POLL_MS = 60_000;
const OVERLAY_ID = "app-build-reload-overlay";

declare const __APP_BUILD_ID__: string;

function hardReload(): void {
  const url = new URL(window.location.href);
  url.searchParams.set("_build", Date.now().toString(36));
  window.location.replace(url.toString());
}

function showReloadOverlay(): void {
  if (document.getElementById(OVERLAY_ID)) return;

  const overlay = document.createElement("div");
  overlay.id = OVERLAY_ID;
  overlay.setAttribute("role", "alertdialog");
  overlay.setAttribute("aria-modal", "true");
  overlay.setAttribute("aria-labelledby", "app-build-reload-title");
  overlay.innerHTML = `
    <div class="app-build-reload-card">
      <h2 id="app-build-reload-title" class="app-build-reload-title">มีเวอร์ชันใหม่</h2>
      <p class="app-build-reload-lede">
        แอปอัปเดตแล้ว ต้องรีโหลดเต็มจอเพื่อเล่นต่อ
      </p>
      <button type="button" class="app-build-reload-btn" id="app-build-reload-btn">
        รีโหลดเต็มจอ
      </button>
    </div>
  `;

  const style = document.createElement("style");
  style.textContent = `
    #${OVERLAY_ID} {
      position: fixed;
      inset: 0;
      z-index: 2147483646;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1.25rem;
      padding-top: calc(1.25rem + env(safe-area-inset-top, 0px));
      padding-bottom: calc(1.25rem + env(safe-area-inset-bottom, 0px));
      background: rgba(8, 10, 14, 0.92);
      backdrop-filter: blur(8px);
      -webkit-backdrop-filter: blur(8px);
    }
    .app-build-reload-card {
      width: min(100%, 22rem);
      padding: 1.25rem 1.35rem;
      border-radius: 14px;
      border: 1px solid rgba(255, 255, 255, 0.12);
      background: #1a2332;
      box-shadow: 0 16px 48px rgba(0, 0, 0, 0.55);
      text-align: center;
      color: #e8eef5;
      font-family: system-ui, -apple-system, "Segoe UI", sans-serif;
    }
    .app-build-reload-title {
      margin: 0 0 0.5rem;
      font-size: 1.15rem;
      font-weight: 700;
    }
    .app-build-reload-lede {
      margin: 0 0 1rem;
      font-size: 0.9rem;
      line-height: 1.45;
      color: #9aa5b5;
    }
    .app-build-reload-btn {
      width: 100%;
      min-height: 44px;
      padding: 0.65rem 1rem;
      border: none;
      border-radius: 10px;
      background: #6ec8ff;
      color: #0a1018;
      font-size: 1rem;
      font-weight: 700;
      cursor: pointer;
    }
    .app-build-reload-btn:hover {
      filter: brightness(1.05);
    }
  `;

  document.head.append(style);
  document.body.append(overlay);
  document.body.style.overflow = "hidden";

  overlay.querySelector<HTMLButtonElement>("#app-build-reload-btn")?.addEventListener("click", () => {
    hardReload();
  });

  window.setTimeout(() => {
    if (document.getElementById(OVERLAY_ID)) hardReload();
  }, 12_000);
}

async function fetchServerBuildId(): Promise<string | null> {
  const res = await fetch(`/build-id.json?t=${Date.now()}`, {
    cache: "no-store",
    credentials: "same-origin",
  });
  if (!res.ok) return null;
  const data = (await res.json()) as { id?: string };
  return typeof data.id === "string" ? data.id : null;
}

export function startBuildUpdateWatch(): () => void {
  const clientId = __APP_BUILD_ID__;
  let stopped = false;

  const check = async (): Promise<void> => {
    if (stopped) return;
    try {
      const serverId = await fetchServerBuildId();
      if (!serverId || serverId === clientId) return;
      showReloadOverlay();
    } catch {
      // offline or dev without endpoint
    }
  };

  if (!import.meta.env.DEV) {
    void check();
  }

  const interval = window.setInterval(() => {
    void check();
  }, POLL_MS);

  const onFocus = (): void => {
    void check();
  };
  const onVisibility = (): void => {
    if (document.visibilityState === "visible") void check();
  };

  window.addEventListener("focus", onFocus);
  document.addEventListener("visibilitychange", onVisibility);

  return () => {
    stopped = true;
    window.clearInterval(interval);
    window.removeEventListener("focus", onFocus);
    document.removeEventListener("visibilitychange", onVisibility);
  };
}
